var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 106,
    viewBox: "0 0 86 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12387_385803)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "#FF9D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.083 98.9898C107.005 100.137 118.422 99.4154 117.869 106.343C117.294 113.511 101.336 119.405 87.4126 118.255C73.4911 117.109 67.2158 105.099 67.4482 102.188C67.6834 99.2724 79.162 97.8428 93.083 98.9898Z",
    fill: "#FF9B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.6781 40.9443C-27.7417 30.314 -33.8243 20.6258 -39.123 25.1198C-44.6054 29.7732 -40.0683 46.1696 -31.0035 56.8008C-21.9421 67.4313 -8.52892 65.5077 -6.29841 63.617C-4.07124 61.7255 -9.61478 51.5724 -18.6781 40.9443Z",
    fill: "#FF9B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8857 140.531C57.3036 168.99 31.1425 163.025 2.59478 148.397L-6.0165 143.985C-34.5642 129.357 -54.6851 111.608 -40.103 83.1489L-9.30149 23.0361C5.28061 -5.4227 40.2428 -16.6377 68.7905 -2.00999L77.4018 2.40237C105.95 17.0301 117.269 51.9596 102.687 80.4184L71.8857 140.531Z",
    fill: "#FF9B2E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.4726 97.7393C86.446 99.7428 72.1905 127.387 71.1062 129.135C54.8556 155.407 32.2601 153.628 2.09483 138.171C-28.255 122.62 -42.8894 105.207 -30.6673 76.362C-29.9306 74.6233 -15.8947 47.0768 -14.9603 45.2532C1.47736 13.173 33.8423 -3.07739 66.0213 13.4109C98.2002 29.8993 103.91 65.6591 87.4726 97.7393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 36.9879,
    cy: 70.6623,
    rx: 62.0066,
    ry: 41.2383,
    transform: "rotate(27.1303 36.9879 70.6623)",
    fill: "url(#paint0_radial_12387_385803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0628 63.0974C83.5778 73.8021 70.4249 78.0158 59.6914 72.516C48.9537 67.0141 44.6954 53.879 50.1805 43.1743C55.6648 32.471 68.8143 28.2538 79.5519 33.7557C90.2855 39.2555 94.5471 52.3941 89.0628 63.0974Z",
    fill: "#FF9B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3478 61.1936C80.9111 69.8525 70.2734 73.2641 61.5879 68.8137C52.9024 64.3633 49.4581 53.7361 53.8948 45.0773C58.3316 36.4184 68.9692 33.0068 77.6548 37.4572C86.3403 41.9076 89.7846 52.5348 85.3478 61.1936Z",
    fill: "url(#paint1_radial_12387_385803)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0785 57.4696C75.6918 62.1273 69.9696 63.9625 65.2975 61.5685C60.6254 59.1746 58.7726 53.458 61.1592 48.8002C63.5458 44.1425 69.2681 42.3073 73.9402 44.7012C78.6123 47.0952 80.4651 52.8118 78.0785 57.4696Z",
    fill: "url(#paint2_radial_12387_385803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5765 55.1624C72.4605 57.3404 69.783 58.1991 67.5997 57.0804C65.4136 55.9603 64.5467 53.2854 65.6627 51.1074C66.7787 48.9294 69.4561 48.0708 71.6422 49.1909C73.8256 50.3096 74.6925 52.9844 73.5765 55.1624Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8783 43.3393C46.3933 54.044 33.2458 58.2605 22.5082 52.7586C11.7719 47.2574 7.51089 34.1209 12.9959 23.4162C18.4809 12.7116 31.6324 8.49712 42.3687 13.9983C53.1064 19.5002 57.3633 32.6347 51.8783 43.3393Z",
    fill: "#FF9B2E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1633 41.4364C43.7265 50.0952 33.0889 53.5069 24.4033 49.0565C15.7178 44.6061 12.2735 33.9789 16.7103 25.3201C21.147 16.6612 31.7847 13.2496 40.4702 17.7C49.1557 22.1504 52.6 32.7776 48.1633 41.4364Z",
    fill: "url(#paint3_radial_12387_385803)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8993 37.7131C38.5123 42.3716 32.7892 44.207 28.1164 41.8127C23.4435 39.4184 21.5905 33.7009 23.9775 29.0425C26.3644 24.384 32.0875 22.5485 36.7604 24.9429C41.4332 27.3372 43.2862 33.0546 40.8993 37.7131Z",
    fill: "url(#paint4_radial_12387_385803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3978 35.4064C35.2811 37.5858 32.6009 38.4431 30.4176 37.3244C28.2302 36.2035 27.3646 33.5294 28.4813 31.3501C29.5973 29.1721 32.2741 28.3113 34.4615 29.4321C36.6449 30.5509 37.5138 33.2284 36.3978 35.4064Z",
    fill: "#2E2A49"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.5697,
    cy: 29.2106,
    rx: 5.29165,
    ry: 4.05317,
    transform: "rotate(27.1303 34.5697 29.2106)",
    fill: "url(#paint5_linear_12387_385803)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.0406,
    cy: 48.4097,
    rx: 5.29165,
    ry: 4.05317,
    transform: "rotate(27.1303 72.0406 48.4097)",
    fill: "url(#paint6_linear_12387_385803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2586 69.8491C11.019 56.4041 -7.15754 41.0222 -14.1678 32.091C-11.6558 38.707 6.88953 56.4488 36.3817 71.5604C65.646 86.5553 91.2173 91.3572 98.0052 89.5081C86.6136 89.0239 63.2946 83.1898 37.2586 69.8491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3735 69.6253C11.1339 56.1803 -7.04197 40.7969 -14.0523 31.8658C-11.5402 38.4818 7.00579 56.2222 36.498 71.3339C65.7622 86.3287 91.3322 91.1333 98.1208 89.2828C86.7285 88.8 63.4095 82.966 37.3735 69.6253Z",
    fill: "#6D0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3545 67.5316L31.9813 70.2115C30.7378 72.6384 31.703 75.6163 34.136 76.863C36.5704 78.1104 39.5513 77.1544 40.7948 74.7275L42.168 72.0476L33.3545 67.5316Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0446 67.8854L32.8863 70.1459C31.8376 72.1927 32.65 74.7029 34.7031 75.7549C36.7548 76.8062 39.2696 76.0008 40.3184 73.954L41.4767 71.6935L34.0446 67.8854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 9.90308,
    height: 2.90785,
    transform: "matrix(0.889971 0.456016 0.456016 -0.889971 32.0295 70.12)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.43 72.6136C43.4251 72.6265 43.4182 72.6366 43.4147 72.6468L41.7485 76.3601C40.2301 79.7513 41.7515 83.7367 45.1546 85.2635C48.5543 86.7903 52.5452 85.2775 54.0628 81.8876L55.7291 78.1743C55.7333 78.1628 55.7395 78.1506 55.7444 78.1412L43.43 72.6136Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3953 73.0486L44.3821 73.0743L42.9778 76.2062C41.6944 79.0653 42.9807 82.4263 45.8481 83.7146C48.7149 85.0007 52.0788 83.7252 53.3615 80.8674L54.7658 77.7355C54.7707 77.7261 54.7755 77.7166 54.777 77.7071L44.3953 73.0486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 13.4983,
    height: 3.96279,
    transform: "matrix(-0.912307 -0.409508 -0.409218 0.912437 55.7432 78.1394)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0801 78.5902L57.0697 78.6105L56.2332 80.8617C55.4699 82.9164 56.5187 85.2062 58.579 85.9732C60.6427 86.7437 62.9313 85.6977 63.6966 83.6423L64.5345 81.3919C64.538 81.3851 64.538 81.3783 64.5402 81.3708L57.0801 78.5902Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6636 78.8089L57.6552 78.8251L56.9499 80.7233C56.3066 82.4569 57.1901 84.3871 58.9298 85.0342C60.6668 85.6834 62.5982 84.8028 63.2422 83.0679L63.9516 81.1717C63.951 81.1663 63.9545 81.1595 63.9545 81.1527L57.6636 78.8089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 7.96332,
    height: 2.33945,
    transform: "matrix(-0.937075 -0.349127 -0.348457 0.937325 64.5438 81.3712)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2505 82.0376C66.249 82.0471 66.2476 82.0566 66.2427 82.0661L65.2997 85.1304C64.4366 87.9281 66.0131 90.8999 68.8201 91.7678C71.6258 92.6349 74.5956 91.0686 75.4587 88.2708L76.4024 85.2052C76.4066 85.1971 76.4073 85.189 76.4095 85.1781L66.2505 82.0376Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0474 82.2844C67.0474 82.2912 67.0432 82.2993 67.0411 82.3068L66.2446 84.891C65.5182 87.2516 66.8459 89.756 69.2125 90.487C71.5785 91.2193 74.0841 89.9003 74.8139 87.5397L75.607 84.9554C75.6077 84.9473 75.6119 84.9392 75.614 84.9317L67.0474 82.2844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 10.6355,
    height: 3.12094,
    transform: "matrix(-0.95535 -0.295477 -0.294475 0.955659 76.4118 85.179)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6194 86.0582C79.6186 86.0663 79.6172 86.0759 79.613 86.084L78.9419 88.9955C78.3274 91.6525 79.9891 94.3075 82.6524 94.9241C85.3185 95.5455 87.9722 93.8907 88.5873 91.2357L89.2564 88.3249C89.2599 88.3181 89.2614 88.3086 89.2621 88.3005L79.6194 86.0582Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3772 86.2335C80.3738 86.2402 80.371 86.249 80.3709 86.2558L79.8038 88.71C79.287 90.9491 80.6872 93.1883 82.933 93.7105C85.1814 94.234 87.4192 92.8392 87.938 90.5995L88.5017 88.1453C88.5045 88.1399 88.5059 88.1304 88.5067 88.1222L80.3772 86.2335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 9.89977,
    height: 2.90686,
    transform: "matrix(-0.974047 -0.226348 -0.224934 0.974374 89.2616 88.2999)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2638 65.8332L30.2507 65.8589L28.5856 68.7274C27.0685 71.3472 23.7065 72.2377 21.0783 70.7134C18.448 69.1897 17.5515 65.8336 19.07 63.2145L20.7337 60.3454L20.7476 60.3183L30.2638 65.8332Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5182 65.4004L29.5065 65.4234L28.1049 67.8411C26.8224 70.0499 23.9884 70.7994 21.7717 69.515C19.5564 68.2313 18.7965 65.3978 20.0784 63.1903L21.4806 60.7713C21.4841 60.7645 21.4882 60.7564 21.4944 60.7511L29.5182 65.4004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 10.9962,
    height: 3.23164,
    transform: "matrix(0.865212 0.501407 0.501682 -0.865052 19.1263 63.1119)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4664 59.4125L19.456 59.4328L18.1173 61.4267C16.8954 63.2464 14.4236 63.7305 12.5982 62.5082C10.7674 61.2832 10.2797 58.8146 11.501 56.9929L12.8382 54.9983C12.8417 54.9915 12.8472 54.9875 12.852 54.9814L19.4664 59.4125Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9472 59.0648L18.9389 59.081L17.8102 60.7623C16.7788 62.2971 14.696 62.7073 13.1546 61.6732C11.6131 60.6425 11.1997 58.5605 12.2318 57.0244L13.3571 55.3431C13.3613 55.3383 13.3647 55.3316 13.3702 55.3276L18.9472 59.0648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 7.9633,
    height: 2.33944,
    transform: "matrix(0.830725 0.556683 0.557278 -0.830326 11.5472 56.9221)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0719 54.6491C12.0664 54.6565 12.0608 54.6673 12.054 54.674L9.96597 57.5086C8.05999 60.0982 4.40863 60.6474 1.81028 58.7371C-0.78672 56.8274 -1.34677 53.1825 0.559208 50.5929L2.64788 47.7604C2.65273 47.751 2.6596 47.7442 2.66717 47.7361L12.0719 54.6491Z",
    fill: "#EDDD9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.333 54.1058C11.3296 54.1125 11.3227 54.1193 11.3192 54.126L9.55808 56.5166C7.95002 58.6986 4.87251 59.1645 2.67979 57.5525C0.490447 55.9439 0.0174817 52.868 1.62554 50.686L3.38669 48.2954C3.39287 48.29 3.3977 48.2839 3.40185 48.2758L11.333 54.1058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    width: 11.6754,
    height: 3.42797,
    transform: "matrix(0.805784 0.59221 0.592992 -0.805208 0.63147 50.4929)",
    fill: "#E66D28"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.8679 131.256C47.2588 142.203 26.1859 142.608 5.80025 132.163C-14.5827 121.718 -26.5626 104.377 -20.9535 93.4306C-15.3444 82.4837 5.72846 82.0788 26.1114 92.5229C46.497 102.968 58.477 120.309 52.8679 131.256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.8479,
    cy: 39.562,
    rx: 52.4626,
    ry: 39.698,
    transform: "rotate(27.1303 52.8479 39.562)",
    fill: "url(#paint7_linear_12387_385803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5446 7.16912L69.5197 5.47911C69.5197 5.47911 73.0056 -14.7162 64.2528 -22.0406C70.0242 -7.90533 60.5446 7.16912 60.5446 7.16912Z",
    fill: "url(#paint8_linear_12387_385803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6899 3.39583L78.5594 10.7511C78.5594 10.7511 82.5919 -5.94622 96.2659 -11.4652C85.3185 -12.6075 73.6899 3.39583 73.6899 3.39583Z",
    fill: "url(#paint9_linear_12387_385803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6397 7.2496L83.759 12.1157C83.759 12.1157 89.2472 4.07238 97.6029 3.87649C92.0208 1.08851 82.6397 7.2496 82.6397 7.2496Z",
    fill: "url(#paint10_linear_12387_385803)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12387_385803",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9879 70.6623) scale(62.0066 41.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_12387_385803",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.621 53.1356) rotate(27.1303) scale(17.6708 17.6166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12387_385803",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.6192 53.1348) rotate(27.1303) scale(9.5055 9.47632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12387_385803",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4375 33.378) rotate(27.1303) scale(17.6708 17.6165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12387_385803",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4376 33.378) rotate(27.1303) scale(9.50693 9.47775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A4E1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12387_385803",
    x1: 34.5793,
    y1: 25.1574,
    x2: 34.5793,
    y2: 29.1272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12387_385803",
    x1: 72.0503,
    y1: 44.3565,
    x2: 72.0503,
    y2: 48.3263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12387_385803",
    x1: 52.9435,
    y1: -0.136032,
    x2: 52.9435,
    y2: 16.4976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12387_385803",
    x1: 72.6731,
    y1: 4.88501,
    x2: 60.5514,
    y2: 7.20492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12387_385803",
    x1: 71.975,
    y1: 0.814201,
    x2: 78.5292,
    y2: 10.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12387_385803",
    x1: 82.25,
    y1: 5.53908,
    x2: 83.7338,
    y2: 12.1214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B01622"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12387_385803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterIcon1);
export default __webpack_public_path__ + "static/media/MonsterIcon1.f47146446c8e0807879383aaf69f5791.svg";
export { ForwardRef as ReactComponent };